export function frameEditorLink({ lessonId, frameId }: { lessonId: string; frameId: string }) {
    return `/editor/lesson/${lessonId}/edit?frame=${frameId}`;
}
